import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from './_services/AuthService.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  jwtService = new JwtHelperService();

  constructor(private _authService: AuthServiceService) {}

  ngOnInit() {
    const token = localStorage.getItem('token');
    if (token) {
      this._authService.decodedToken = this.jwtService.decodeToken(token);
    }
  }

}
